<!-- /** * * IMPORTANT: * This file is used both in vue2 and vue3
 * Dont use the vue syntax and the store concept in this file.
* For any clarifications please contact Leela * */
 -->

<template>
  <div v-if="assetUrl" class="h-100" :class="[setMatchHeight ? 'set-match-height' : '']">
    <video
      v-if="assetType === 'video'"
      :class="evoxmediaclass"
      :style="evoxmediastyles"
      autoplay
      muted
      :loop="loop"
    >
      <source :src="assetUrl" type="video/mp4" />
    </video>
    <img
      v-if="assetType === 'image' && !width"
      :src="assetUrl"
      :class="imgclass"
      :style="imgstyles"
      :alt="alt"
    />
    <img
      v-if="assetType === 'image' && width"
      :src="assetUrl"
      :class="imgclass"
      :style="imgstyles"
      :alt="alt"
      :width="width"
      :height="height"
    />

    <loading-gif v-if="showLoadingGif" />
  </div>
</template>
<script>
import LoadingGif from "../shared/loadingGif.vue";
import { EvoxMediaDriveIn } from "./EvoxMediaApiService";

export default {
  components: {
    LoadingGif,
  },
  props: {
    styleid: {
      required: false,
      type: Number,
      default: 0,
    },
    imgurl: {
      required: false,
      type: String,
      default: "",
    },
    imgprops: {
      required: false,
      type: String,
      default: "",
    },
    imgstyles: {
      required: false,
      type: String,
      default: "",
    },
    imgclass: {
      required: false,
      type: String,
      default: "",
    },
    evoxmediaprops: {
      required: false,
      type: String,
      default: "",
    },
    evoxmediastyles: {
      required: false,
      type: String,
      default: "",
    },
    evoxmediaclass: {
      required: false,
      type: String,
      default: "",
    },
    alt: {
      required: false,
      type: String,
      default: "",
    },
    loop: {
      required: false,
      type: Boolean,
      default: false,
    },
    animationType: {
      required: false,
      type: String,
      default: "",
    },
    showOnlyEvoxImage: {
      required: false,
      default: false,
      type: Boolean,
    },
    setMatchHeight: {
      required: false,
      default: false,
      type: Boolean,
    },
    width: {
      default: 0,
      required: false,
      type: Number,
    },
    height: {
      default: 0,
      required: false,
      type: Number,
    },
  },
  data() {
    return {
      assetUrl: "",
      assetType: "",
      useOverrides: window.digiServiceUseOverrides,
      showLoadingGif: false,
    };
  },
  mounted() {
    if (window.enableEvoxDriveIn && this.styleid && !this.showOnlyEvoxImage) {
      EvoxMediaDriveIn(this.styleid, this.animationType, this.evoxmediaprops).then((response) => {
        if (response && response.assetType === "video") {
          this.assetUrl = response.assetUrl;
          this.assetType = response.assetType;
        } else {
          this.setEvoxImage();
        }
      });
    } else {
      this.setEvoxImage();
    }
  },
  methods: {
    setEvoxImage() {
      let evoxImgUrl;
      if (this.imgurl) {
        evoxImgUrl = this.imgurl;
      } else {
        evoxImgUrl = `https://service.secureoffersites.com/images/GetEvoxImage?styleid=${this.styleid}`;
      }

      if (this.useOverrides) {
        evoxImgUrl = evoxImgUrl + `&useoverrides=${this.useOverrides}`;
      }
      this.assetUrl = evoxImgUrl;
      this.assetType = "image";
    },
  },
};
</script>
